import { ReferenceData } from '../../lib/models/reference-data.model';

export class AnsweredQuestionViewModel extends ReferenceData {
  public ProvidedAnswer: string;
}
